import React, { useEffect } from "react"
import TechnologiesList from "../../features/technologies-list"
import AndroidLogo from "../../assets/images/technologies/Android.svg"
import FirebaseLogo from "../../assets/images/technologies/firebase.svg"
import RealmLogo from "../../assets/images/technologies/realmio.svg"
import KotlinLogo from "../../assets/images/technologies/kotlin.svg"
import CaseProjectBlock from "../../features/case-project-block"
import { PROJECT_HELLO } from "../../data/cases/project-data"
import CasesSays from "../../features/cases-client"
import { DEVELOPERS_LIST_HELLO } from "../../data/cases/developers-data"
import CaseDeveloper from "../../features/case-developer"
import { HELLO } from "../../data/cases/seo-says"
import ChallengesSolutions from "../../features/challenges-solutions"
import { CHALLENGES_LIST_HELLO } from "../../data/cases/challenges-data"
import { SOLUTIONS_LIST_HELLO } from "../../data/cases/solutions-data"
import { HEADER_HELLO } from "../../data/cases/headers-data"
import { OtherCases } from "../../features/other-cases"
import CaseCustomHeader from "../../features/case-custom-header"
import "./index.scss"
import { useMediaQuery } from "react-responsive"
import { DESKTOP_WIDTH } from "../../constants/common"
import { Helmet } from "react-helmet-async"

const Hello = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const isDesktop = useMediaQuery({ minWidth: DESKTOP_WIDTH })

    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft - Hello</title>
            </Helmet>
            <div className="hello">
                <CaseCustomHeader {...HEADER_HELLO} />
                <div className="try-now-image">
                    <img
                        src="https://s3.amazonaws.com/staging.newsoft-website-v2/media/hello_case/Hello.webp"
                        alt="Hello main"
                    />
                </div>
                <TechnologiesList
                    title="Key technologies"
                    className={"technologies-horizontal"}
                >
                    <img
                        src={AndroidLogo}
                        alt="Android logo"
                        style={isDesktop ? { width: "52px" } : {}}
                    />
                    <img
                        src={FirebaseLogo}
                        alt="Firebase logo"
                        style={isDesktop ? { width: "154px" } : {}}
                    />
                    <img
                        src={RealmLogo}
                        alt="Pednet logo"
                        style={isDesktop ? { width: "125px" } : {}}
                    />
                    <img
                        src={KotlinLogo}
                        alt="Kotlin logo"
                        style={isDesktop ? { width: "145px" } : {}}
                    />
                </TechnologiesList>
                <CaseProjectBlock {...PROJECT_HELLO} />
                <div className="try-now-developers">
                    <h2 className="t-s3 desk">developer quotes</h2>
                    {DEVELOPERS_LIST_HELLO.map((el, id) => (
                        <CaseDeveloper
                            key={el.name}
                            {...el}
                            header={id === 0 && "developer quotes"}
                        />
                    ))}
                </div>
                <CasesSays data={HELLO} header="What our CEO says" />
                <ChallengesSolutions
                    challenges={CHALLENGES_LIST_HELLO}
                    solutions={SOLUTIONS_LIST_HELLO}
                />
                <OtherCases currentCase="/cases/quarkworks/hello" />
            </div>
        </>
    )
}

export default Hello
